export const CREATE_DEPLOYMENT = 'CREATE_DEPLOYMENT';
export const GET_AGENT_DEPLOYMENTS = 'GET_AGENT_DEPLOYMENTS';
export const GET_FACEBOOK_MENUS = 'GET_FACEBOOK_MENUS';
export const CREATE_FACEBOOK_MENU = 'CREATE_FACEBOOK_MENU';
export const DELETE_FACEBOOK_MENU = 'DELETE_FACEBOOK_MENU';
export const CREATE_FACEBOOK_MENU_ITEM = 'CREATE_FACEBOOK_MENU_ITEM';
export const UPDATE_FACEBOOK_MENU_ITEM = 'UPDATE_FACEBOOK_MENU_ITEM';
export const DELETE_FACEBOOK_MENU_ITEM = 'DELETE_FACEBOOK_MENU_ITEM';
export const DELETE_FACEBOOK_MENU_ALL_ITEMS = 'DELETE_FACEBOOK_MENU_ALL_ITEMS';

export const DEPLOYMENTS = {
  WEBCHAT: 2,
  FACEBOOK: 1,
};

export const DEPLOYMENT_TYPES = {
  WEBCHAT: 'WEBCHAT',
  FACEBOOK: 'FACEBOOK',
};
